export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/announcements/state.js